import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="pt-32 pb-20 md:pt-48 md:pb-32 px-6 md:px-12 max-w-7xl mx-auto min-h-screen flex items-center">
      <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="order-2 md:order-1"
        >
          <span className="text-brand-600 font-semibold tracking-wider uppercase text-sm mb-4 block">
            New Release by Andrei Marius Ciomîrtan
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-stone-900 leading-[1.1] mb-6">
            The Silent Language of Love:<br />
            <span className="text-brand-600 italic">8 Signs He's More Romantic Than You Know.</span>
          </h1>
          
          <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed max-w-lg">
            What if the most romantic thing he ever does is simply stay? This book teaches you to see the love that was always there — hidden inside everyday acts of care, loyalty, and quiet devotion.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => document.getElementById('get-copy').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-stone-900 text-white rounded-full hover:bg-brand-700 transition-all duration-300 font-medium text-center shadow-lg shadow-stone-900/20"
            >
              Order Now
            </button>
            <button 
              onClick={() => document.getElementById('the-book').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-stone-200 text-stone-900 rounded-full hover:bg-stone-300 transition-all duration-300 font-medium text-center"
            >
              Read an Excerpt
            </button>
          </div>

          {/* Social proof strip */}
          <div className="mt-10 pt-8 border-t border-stone-200 flex items-center gap-6 flex-wrap">
            {['Relationship Insight', 'Emotional Depth', 'Practical Wisdom'].map((tag) => (
              <span key={tag} className="flex items-center gap-2 text-stone-500 text-sm">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-400 inline-block"></span>
                {tag}
              </span>
            ))}
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="order-1 md:order-2 flex justify-center relative"
        >
          <div className="absolute inset-0 bg-brand-300/30 blur-3xl rounded-full transform -translate-y-10 scale-110"></div>
          
          <img 
            src="https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/3614b5604f8ec9fc0b13dbae720eb360.jpg" 
            alt="The Silent Language of Love - Book Cover" 
            className="w-full max-w-[300px] md:max-w-[380px] rounded-xl shadow-2xl relative z-10 transform transition-transform hover:scale-[1.02] duration-500 object-cover aspect-[2/3]"
          />
          
          <div className="absolute inset-0 max-w-[300px] md:max-w-[380px] mx-auto z-20 rounded-xl shadow-[inset_4px_0_10px_rgba(0,0,0,0.15)] pointer-events-none"></div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 bg-white/95 backdrop-blur-sm px-5 py-3 rounded-full shadow-lg whitespace-nowrap hidden md:block">
            <p className="font-serif italic text-stone-700 text-sm">"A revelation for modern relationships."</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;